function initializeGoalStudios() {
  document.querySelectorAll("[data-goal-studio]").forEach((studio) => {
    if (studio.dataset.initialized === "true") return
    studio.dataset.initialized = "true"

    const goalList = studio.querySelector("[data-goal-list]")
    const goalTemplate = studio.querySelector("[data-goal-template]")
    const termTemplate = studio.querySelector("[data-term-template]")
    const emptyState = studio.querySelector("[data-goal-empty]")
    let nextIndex = Date.now()

    function refresh() {
      const goals = [...goalList.querySelectorAll(":scope > [data-goal-card]")]
      goals.forEach((goal, index) => {
        goal.querySelector("[data-goal-number]").textContent = String(index + 1).padStart(2, "0")
        goal.querySelectorAll("[data-term-goal]").forEach((termGoal, termIndex) => {
          termGoal.querySelector("[data-term-number]").textContent = `學期目標 ${termIndex + 1}`
        })
      })
      emptyState.hidden = goals.length > 0
    }

    function goalIndexFor(card) {
      const field = card.querySelector('[name^="document[goal_sets]"]')
      return field?.name.match(/document\[goal_sets\]\[([^\]]+)\]/)?.[1]
    }

    function addTermGoal(card) {
      const goalIndex = goalIndexFor(card)
      if (!goalIndex) return

      const termIndex = nextIndex++
      const html = termTemplate.innerHTML
        .replaceAll("__GOAL__", goalIndex)
        .replaceAll("__TERM__", termIndex)
      card.querySelector("[data-term-list]").insertAdjacentHTML("beforeend", html)
      refresh()
    }

    studio.addEventListener("click", (event) => {
      const addGoal = event.target.closest("[data-add-goal]")
      if (addGoal) {
        const goalIndex = nextIndex++
        const html = goalTemplate.innerHTML.replaceAll("__GOAL__", goalIndex)
        goalList.insertAdjacentHTML("beforeend", html)
        const card = goalList.lastElementChild
        addTermGoal(card)
        card.scrollIntoView({ behavior: "smooth", block: "center" })
        card.querySelector("input:not([type='hidden'])")?.focus()
        refresh()
        return
      }

      const addTerm = event.target.closest("[data-add-term-goal]")
      if (addTerm) {
        addTermGoal(addTerm.closest("[data-goal-card]"))
        return
      }

      const removeTerm = event.target.closest("[data-remove-term-goal]")
      if (removeTerm) {
        removeTerm.closest("[data-term-goal]")?.remove()
        refresh()
        return
      }

      const removeGoal = event.target.closest("[data-remove-goal]")
      if (removeGoal && window.confirm("確定移除這個學年目標及其所有學期評量嗎？")) {
        removeGoal.closest("[data-goal-card]")?.remove()
        refresh()
      }
    })

    refresh()
  })
}

document.addEventListener("DOMContentLoaded", initializeGoalStudios)
document.addEventListener("turbo:load", initializeGoalStudios)
